import { memo } from "react";

import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import { getIOSAppDetails } from "../../../../../../redux/slices/landingPages/landingPages.asyncActions";
import PageContentStep from "./PageContentStep.layout";

const mapStateToProps = (state: any) => ({
    templates: state.landingPages.templates,
    gamificationTemplates: state.landingPages.gamificationTemplates,
    isLandingPageFormLoading: state.landingPages.isLandingPageFormLoading,

    customSources: state.landingPages.customSources,
    trackers: state.allTrackersState.trackers,
    mmpDetails: state.landingPages.mmpDetails,
    appDetails: state.landingPages.appDetails,
});

const mapDispatchToProps = (dispatch: any): any => ({
    dispatchGetAppDetails: (iosAppId: any) =>
        dispatch(getIOSAppDetails(iosAppId)),
});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(memo(PageContentStep));
